import React from 'react';
import './OurTeam.css';
import { NavLink } from 'react-router-dom';

const OurTeam = () => {
  return (
    <section>
      <div className="container">
        <h2 className="text-left team-Container-h2">
          Board of <span className="team-container-span">Directors</span>
        </h2>
        <div className="team-Container">
          <div className="container ourteam-container">
            <div className="row">
              <div className="col-md-4 col-sm-6 bottom-card">
                <div className="card text-center ourteam-card">
                  <NavLink to="/about/board-of-directors/sandip-dalvi">
                    <img
                      src="../image/team.png"
                      alt="Sandip Dalvi"
                      className="card-img-top component-person"
                    />
                  </NavLink>
                  <div className="card-body">
                    <h5 className="component-name">Sandip Dalvi</h5>
                    <p className="card-text component-role">Co-Founder & Co-CEO</p>
                    <NavLink to="/about/board-of-directors/sandip-dalvi" className="know-more-tab">
                      Know More
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 bottom-card">
                <div className="card text-center ourteam-card">
                  <NavLink to="/about/board-of-directors/akshay-kothe">
                    <img
                      src=""
                      alt="Akshay Kothe"
                      className="card-img-top component-person"
                    />
                  </NavLink>
                  <div className="card-body">
                    <h5 className="component-name">Akshay Kothe</h5>
                    <p className="card-text component-role">Co-Founder & Co-CEO</p>
                    <NavLink to="/about/board-of-directors/akshay-kothe" className="know-more-tab">
                      Know More
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 bottom-card">
                <div className="card text-center ourteam-card">
                  <NavLink to="/about/board-of-directors/nicolas-marais">
                    <img
                      src=""
                      alt="Nicolas Marais"
                      className="card-img-top component-person"
                    />
                  </NavLink>
                  <div className="card-body">
                    <h5 className="component-name">Nicolas Marais</h5>
                    <p className="card-text component-role">Co-Founder & Co-CEO</p>
                    <NavLink to="/about/board-of-directors/nicolas-marais" className="know-more-tab">
                      Know More
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
